import React from "react";
import Page, { PageProps } from "../Page";
import { IVerificationPresenter } from "../../../presenter/authentication/VerificationPresenter";
import VerificationForm from "./VerificationForm";

export interface Props extends PageProps {}
export interface State extends IVerificationPresenter {}

export default class VerificationPage extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe(result => {
      return this.setState(prevState => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    let {
      verificationCode,
      onChangeVerificationCode,
      translate,
      application,
      submitVerificationCode
    } = this.state;

    return (
      <Page
        {...this.props}
        style={{
          display: "flex",
          justifyContent: "center",
          height: "100%",
          width: "100%"
        }}
      >
        <VerificationForm
          translate={translate}
          verificationCode={verificationCode}
          onChangeVerificationCode={onChangeVerificationCode}
          title={application.applicationName}
          submitVerificationCode={submitVerificationCode}
          loading={this.state.loaders.verificationLoader}
        />
      </Page>
    );
  }
}
